module.exports = __webpack_public_path__ + "static/media/iconphone.b6e33442.svg";